import * as React from "react";
function SvgXRay(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 5H5v14h14V5zM5 3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2H5zm6 4.107V6h2v1.107c.977.195 1.961.624 2.71 1a19.295 19.295 0 011.806 1.035l.03.02.008.006.003.002h.001L17 10l-.558.83-.005-.004-.02-.013-.089-.058a17.318 17.318 0 00-1.515-.862c-.604-.302-1.237-.57-1.813-.73v1.944c.977.195 1.961.623 2.71 1a19.274 19.274 0 011.806 1.035l.03.02.008.006.003.002h.001L17 14l-.558.83-.005-.004-.02-.013-.089-.058a17.333 17.333 0 00-1.515-.862c-.604-.302-1.237-.57-1.813-.73v1.928c.617.112 1.15.31 1.562.503a6.642 6.642 0 01.956.546l.062.045.02.015.007.005.002.002h.001v.001L15 17l-.611.792h.001l-.026-.018a4.639 4.639 0 00-.647-.367C13.265 17.196 12.662 17 12 17c-.662 0-1.265.196-1.717.407a4.635 4.635 0 00-.647.367l-.026.018h.001L9 17a151.87 151.87 0 01-.61-.792v-.001l.003-.002.007-.005.02-.015.062-.045A6.64 6.64 0 0111 15.091v-1.929c-.576.162-1.21.429-1.813.732a17.354 17.354 0 00-1.603.919l-.021.013-.004.003a431.448 431.448 0 00-1.117-1.659l.004-.002.008-.006.03-.02a11.524 11.524 0 01.494-.31c.327-.198.785-.461 1.312-.726.748-.376 1.733-.804 2.71-.999V9.162c-.576.162-1.21.429-1.813.732a17.338 17.338 0 00-1.603.919l-.021.013-.004.003L7 10l-.558-.83.004-.002.008-.006.03-.02.107-.07a19.332 19.332 0 011.699-.966c.748-.375 1.733-.804 2.71-.999zM9.61 17.792l-.002.002.002-.002zm4.78 0l.003.003-.001-.001-.002-.001z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgXRay);
export default ForwardRef;
